import React from 'react';
import envelope from './../../../assets/images/svg/143-envelope.svg';
import print from './../../../assets/images/svg/144-print.svg';


export const LettersSendingModeSection = ({account, setAccount, steps}) => {
    return (
        <div className="block mt-4">
            <div className="card-header py-0 pr-0 pl-4" id="headingSendingMode" role="button">
                <div className="flex-row align-items-center justify-content-lg-between" data-toggle="collapse" data-target="#accordionSendingMode" aria-expanded="false" aria-controls="accordionSendingMode">
                    <h2 className="h3 font-weight-black my-auto"><i className={"eva eva-checkmark-circle-outline fs-4 align-middle mr-1 ml-n4" + (steps[3] === true ? ' text-success' : '')}></i><span className="align-middle">Mode d'envoi des courriers</span></h2>
                    <button type="button" className="btn btn-icon p-0 text-uppercase font-weight-demi fs-4 my-auto ml-auto m-lg-1 o-30" name="refPrincipal"><i className="eva eva-arrow-ios-downward-outline"></i></button>
                </div>
                <hr className="mt-2 mb-0 border-gray" />
            </div>
            <div className="card-body pl-4 pr-0 collapse" id="accordionSendingMode" aria-labelledby="headingSendingMode" data-parent="#accordionCreateDossier">
                <p className="fs-3 font-weight-demi">Choisissez le mode d'envoi des courriers générés</p>
                <div className="grid grid-sm-narrow grid-hd-4">
                    <div className={"card picker-card aling-items-center text-center" + (account.hasDocumentSending === false ? " active" : "")} onClick={() => setAccount({...account, hasDocumentSending:false})}>
                        <div className="card-header pt-sm pb-0">
                            <div className="flex-column h-5 w-5 rounded-max text-center">
                                <img className="img-fluid m-auto" src={print} alt="print" />
                            </div>
                        </div>
                        <div className="card-body px-2">
                            <h5 className="h6 font-weight-demi text-uppercase mb-0 ls-n1">Téléchargement et impression par le client</h5>
                        </div>
                    </div>
                    <div className={"card picker-card aling-items-center text-center" + (account.hasDocumentSending === true ? " active" : "")} onClick={() => setAccount({...account, hasDocumentSending:true})}>
                        <div className="card-header pt-sm pb-0">
                            <div className="flex-column h-5 w-5 rounded-max text-center">
                                <img className="img-fluid m-auto" src={envelope} alt="envelope" />
                            </div>
                        </div>
                        <div className="card-body px-2">
                            <h5 className="h6 font-weight-demi text-uppercase mb-0 ls-n1">Envoi par la poste en recommandé via application</h5>
                        </div>
                    </div>
                </div>
                <div className="invalid-feedback alert">Veuillez choisir une option</div>
            </div>
        </div>
    )
}